export const UIRadio = ({
  id,
  name,
  value,
  checked,
  onChange,
  disabled = false,
}) => (
  <input
    id={id}
    type="radio"
    name={name}
    value={value}
    checked={checked}
    onChange={onChange}
    disabled={disabled}
    className="w-4 h-4 text-green-600 bg-gray-100 border-gray-300 focus:ring-green-500 focus:ring-2"
  />
);
